import { render, staticRenderFns } from "./GalleryHighlight.vue?vue&type=template&id=04676cfa"
import script from "./GalleryHighlight.vue?vue&type=script&lang=js"
export * from "./GalleryHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports